const defaultRawDataProcessor = (setProcessedSupportData, rawSupportData, additionalData) => {
    setProcessedSupportData({...rawSupportData});
};
const fileFiltersRawDataProcessor = (setProcessedSupportData, rawSupportData, additionalData) => {
    setProcessedSupportData({...rawSupportData});
};

export const variantRawDataProcessorMapFilters = {
    defValue: defaultRawDataProcessor,
    fileFilters: fileFiltersRawDataProcessor,
};